var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Unknown "+_vm._s(_vm.type || 'page'))]),_vm._v(" "),_c('p',[_vm._v("This page doesn't actually exist. Oh no!")]),_vm._v(" "),_c('p',[_vm._v("Instead, please accept this exceptionally awesome piece of artwork:")]),_vm._v(" "),_c('p',[_c('awesome',{attrs:{"light":_vm.darkMode}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31ea7a7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UnknownPage.vue
// module id = null
// module chunks = 